// extracted by mini-css-extract-plugin
export default {"item":"IconLink-module--item--ed742","icon":"IconLink-module--icon--620e9"};